import { useFormatting } from '@gat-ship/utils'
import {
  formatCustomFieldValue,
  type CustomFieldFormatters
} from '../model/format-custom-field-value'
import type { ResolvedCustomField } from '../model/types'

export function useCustomFieldFormatting() {
  const { formatDateTime, formatNumber } = useFormatting()

  const formatters: CustomFieldFormatters = {
    formatDateTime,
    formatNumber
  }

  function formatValue(field: ResolvedCustomField, value: unknown): string {
    return formatCustomFieldValue(field, value, formatters)
  }

  return { formatValue }
}
